module.exports = __webpack_public_path__ + "static/media/dropdown.dff96bde.svg";